/* eslint-disable max-len */
import React, { useState, useEffect } from "react";
import { object, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import Headline from "../../atoms/Headline";
import NotificationStories from "../../rows/NotificationStories";
import { staticTexts } from "../../utils/Translate";
import { useAutoRefresh } from "../../utils/react-utils";

import "./notification.m.css";

function NotificationPageBase({ data, publisherAttributes, pageType }) {
  const { stories } = data;
  const [notifications, setNotifications] = useState([]);

  if (!stories.length) {
    return (
      <div styleName={`not-found-wrapper ${publisherAttributes.lang === "en" ? "en-wrapper" : ""}`}>
        <Headline text="no stories found !!" headlineType={1} headerLevel={2} />
      </div>
    );
  }

  useEffect(() => {
    const limit = 8;
    const offset = 0;

    fetch(`/feapi/push-engage-notifications?limit=${limit}&offset=${offset}`)
      .then((res) => res.json())
      .then((resp) => {
        setNotifications(resp.notifications);
      });
  }, []);

  useAutoRefresh(pageType);

  return (
    <React.Fragment>
      <div>
        <div styleName="content">
          <Headline
            text={staticTexts(publisherAttributes.lang).notifications}
            headerLevel={1}
            headlineType={38}
            className="title"
          />
        </div>

        <div>{notifications && <NotificationStories stories={notifications} />}</div>
      </div>
    </React.Fragment>
  );
}

NotificationPageBase.propTypes = {
  data: object,
  publisherAttributes: object,
  pageType: string,
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
  pageType: get(state, ["qt", "pageType"], ""),
});

export const NotificationPage = connect(mapStateToProps, null)(NotificationPageBase);
